// export function concatClass(a, b) {
//   if (a && a.indexOf(b) > -1) return a
//   return a ? (b ? a + ' ' + b : a) : b || ''
// }

export function getTodayStartTime() {
  return new Date(new Date().setHours(0, 0, 0, 0))
}

export function isSameNewDay(dataStr) {
  var date1 = stringToDate(dataStr)
  return isSameDay(date1, new Date())
}
export function timestampToTime(timestamp) {
  var date = new Date(timestamp)
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = date.getDate()
  return Y + M + D
}

export function timestampToTimeMMDD(timestamp) {
  var date = new Date(timestamp)
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = date.getDate()
  return M + D
}

export function timestampToTimeYYYYMMDDHHmm(timestamp) {
  var date = new Date(timestamp)
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = date.getDate()
  return Y + M + D
}

export function stringToDate(dataStr) {
  var sep = '-'
  if (dataStr.indexOf('/') > 1) {
    sep = '/'
  }
  if (dataStr.indexOf('-') > 1) {
    sep = '-'
  }
  var converted = Date.parse(dataStr)
  var myDate = new Date(converted)
  if (isNaN(myDate)) {
    var arys = dataStr.split(sep)
    myDate = new Date(arys[0], arys[1] - 1, arys[2])
  }
  return myDate
}

export function isSameDay(startTime, endTime) {
  const startTimeMs = new Date(startTime).setHours(0, 0, 0, 0)
  const endTimeMs = new Date(endTime).setHours(0, 0, 0, 0)
  return startTimeMs === endTimeMs ? true : false
}

export function getTodayEndTime() {
  return new Date(new Date().setHours(23, 59, 59, 0))
}

// 获取本周的开始
export function getWeekStartTime() {
  var now = new Date()
  // 获取今天是星期几
  var weekDay = now.getDay() || 7
  var date = now.getDate() // 今天几号
  // 为什么要额外减一呢？
  /**
   * 假如今天是周一，则weekDay是1
   * 今天恰好是这周的开始，所以应该减去0，而不是1
   * 同理，今天是周二，则减去1，得到这周开始的那天；
   */
  var startTime = new Date(new Date(now.setDate(date - weekDay - 1)).setHours(0, 0, 0, 0))
  return startTime
}

// 获取本周的结束
export function getWeekEndTime() {
  var now = new Date()
  var weekDay = now.getDay() || 7
  var date = now.getDate()

  var endTime = new Date(new Date(now.setDate(date + 7 - weekDay)).setHours(23, 59, 59, 0))
  return endTime
}

// 获取本周的结束
export function getCurrentFullYear() {
  var now = new Date()
  var fullYear = now.getFullYear()

  return fullYear
}
